import { Component, SimpleChanges, ViewChild } from '@angular/core';
import { Message, ConfirmationService, MessageService, ConfirmEventType } from 'primeng/api';
import { data_item } from 'src/app/misc/interface/data';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { link, breadcrumb, stat } from '../../layout/header/header.component';
import { DataView } from 'primeng/dataview';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['../data/content-update-page/content-update-page.component.scss'],
})
export class CommentsComponent {
  messages: Message[] = [];

  @ViewChild('dv')
  dataView!: DataView;

  translator:TranslatorPipe = new TranslatorPipe()
  header = this.translate('Comments');
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [{ name:  this.translate('Comments'), link: '/admin/comments' }];
  stats: stat[] = [];
  skelition = true
  staticURL = GlobalConstants.staticFilesURL;


  data: any
  filteredData: any

  pages: any[] = [];
  showing: string = '';
  currentPage: number = 1;
  totalPages: number = 0;
  totalRecords: number = 0;
  currentTypeFilter: any = 'all';

  first: number = 0;
  rows: number = 10;
  sortOrder: number = 1;
  sortField: string = '';



  currentComment: any

  //filter options
  treeData: any[] = [];

  rejectionModal = false

  parentOUS = [
    'الجهات المشاركة',
  ];


  //filters
  typeFilter: any = undefined;
  oufilter: any = undefined;


  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private orgUnits: OrgUnitsService,
    private permissionService: PermissionHandlerService,
  ) { }

  ngOnInit() {
    this.currentStatus = this.statusOptions[0].name
    this.getTreeData().then(e => { this.getComments() });
  }

  hasPermission() {
    return this.permissionService.hasPermission('COMMENTS', 'u');
  }

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async getTreeData() {
    this.treeData = await this.permissionService.extractOUChildren('COMMENTS', 'r');
  }

  refresh() {
    this.typeFilter = undefined;
    this.oufilter = undefined;
    this.filteredData = this.data;
    this.currentStatus = this.statusOptions[0].name;
    this.changeCurrent(this.filteredData[0]);
    this.handleStatusChange();
  }

  applyOUFilter(event: any) {
    console.log("EVENT", this.data, event._id);
    this.filteredData = this.data.filter((e: any) => e._id.ous == event._id);

    if (this.filteredData) {
      this.changeCurrent(this.filteredData[0]);
    } else {
      this.currentComment = null;
    }
  }

  changeCurrent(current: any) {
    this.currentComment = cloneDeep(current);

    console.log("==Current", this.currentComment )

  }

  async getComments() {
    try {
      this.skelition = true
      this.currentComment = []
      let res = await this.dataService.getData('comments/'+this.currentStatus)
      console.log('RESOURCE', res);
      if (res.error) {
        return
      }
      this.data = res.data.filter((e: any) => this.applyOUPermission(e._id.ous));
      console.log('RESOURCE', this.data);
      this.filteredData = this.data;
      if (this.filteredData.length > 0) {
        this.changeCurrent(this.filteredData[0])
      }
      this.totalRecords = this.data.length
      this.first = 0;
      this.rows = 10;
      this.skelition = false
      // this.handleStatusChange();
      // this.applyOUPermission();
    } catch (error) {
      console.log(error)
    }
  }

  applyOUPermission(ou: any) {
    let result: boolean = false;
    if (typeof ou == 'string') {
      result = this.orgUnits.childrenContainsId(this.treeData, ou);
    } else {
      if (ou._id) {
        result = this.orgUnits.childrenContainsId(this.treeData, ou._id);
      } else {
        result = this.orgUnits.childrenContains(this.treeData, ou.name);
      }
    }
    return result;
  }

  changeToNumber(arg0: string): number {
    return Number(arg0);
  }

  goToPage(maxPage: number) {
    // Validate input and navigate to the specified page

    console.log(maxPage, this.currentPage, this.currentPage >= 1 && this.currentPage <= maxPage);
    if (this.currentPage >= 1 && this.currentPage <= maxPage) {
      this.dataView.paginate({
        first: (this.currentPage - 1) * this.dataView.rows,
        rows: this.dataView.rows
      });
    }
  }
  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  moveToLast(reverse: boolean) {
    if (reverse) {
      this.first = 0;
      this.rows = this.dataView.rows;
      this.currentPage = 1;
      this.dataView.paginate({ first: this.first, rows: this.rows })
    } else {
      const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
      this.first = (maxPage - 1) * this.dataView.rows;
      this.rows = this.dataView.rows;
      this.currentPage = maxPage;
      this.dataView.paginate({
        first: this.first,
        rows: this.rows
      });
    }
  }

  changePage(n: number) {
    const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
    if (n > 0 && n <= maxPage) {
      console.log(n, this.currentPage, maxPage);
      this.currentPage = n;
      this.goToPage(n);
    }
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dataView.filter($event.target.value, stringVal);
  }

  handleStatusChange() {
    // let current = this.data.find((e: any) => e._id._id == this.currentComment._id._id);
  
    console.log("STATUS", this.currentStatus);
    this.getComments()
    console.log("STATUS 2", this.currentStatus);
  }

  
  statusOptions = [
    { name: 'PENDING', value: 1, arabic : this.translate('PENDING') },
    { name:'APPROVED', value: 2 , arabic : this.translate('acceptable') },
    { name: 'REJECTED', value: 3 ,arabic : this.translate('REJECTED')  }
  ];

  currentStatus: any;

  changeView(_t29: any) {
    this.changeCurrent(_t29);
    // this.handleStatusChange();
  }

  confirmApproveReject(commentData: any) {
    let comment: any = {
      _id: commentData._id,
      data_id: commentData.data_id,
      ou: commentData.ou._id,
      text: commentData.text,
      like: commentData.like,
      status: "APPROVED"
    }

    this.confirm({
      message: this.translate('Are you sure you want to approve this comment?'),
      header:  this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.changeCommentStatus(comment),
    });
  }

  commentData: any;
  sendStatus : string | undefined;

  openRejectModal(data: any , status : string) {
    this.commentData = data;
    // this.rejectionModal = true;
    this.sendStatus = status
    this.confirm({
      message: this.translate('Are you sure you want to approve this comment?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.rejectComment(status),
    });

  }

  rejectComment(status : string) {
    console.log("===> Test world",status)
    if (this.commentData.rejectReason && this.commentData.rejectReason != '') {
      let comment: any = {
        _id: this.commentData._id,
        data_id: this.commentData.data_id,
        ou: this.commentData.ou._id,
        text: this.commentData.text,
        like: this.commentData.like,
        status: status,
        rejectReason: this.commentData.rejectReason
      }
  
      this.changeCommentStatus(comment);
    }
  }


  reason: any = undefined



  //API Call Approve
  async changeCommentStatus(comment: any) {
    try {
      let res = await this.dataService.postData('comments/change-status', comment, 'PUT');
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.reason = null;
      this.rejectionModal = false;
      this.getComments();
    } catch (e: any) {
      console.log(e);
      this.messages = [
        { severity: 'error',  summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }





  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel:'نعم',
      rejectLabel:'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }
}
